import axios from 'axios';
const BASE_URL = 'https://px1.tuyaeu.com/homeassistant/';


export const getCookie = (cname) => {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export const setCookie = (cname, cvalue, exhours) => {
    var d = new Date();
    d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const adjustDevice = (deviceId, action, valueName, newState, callback) => {
    const tuyaAccessToken = getCookie("access_token");
    const regionMap = {
        "EU": "https://px1.tuyaeu.com/homeassistant/",
        "AY": "https://px1.tuyacn.com/homeassistant/",
        "AZ": "https://px1.tuyaus.com/homeassistant/"
    };
    const region = tuyaAccessToken.substring(0, 2);
    const baseUrl = regionMap[region] || "https://px1.tuyaeu.com/homeassistant/";

    const url = `${baseUrl}skill`;
    const headers = { "Content-Type": "application/json" };
    const data = {
        header: {
            name: action,
            namespace: "control",
            payloadVersion: 1,
        },
        payload: {
            accessToken: tuyaAccessToken,
            devId: deviceId,
            [valueName]: newState,
        },
    };

    axios
        .post(url, data, { headers })
        .then((response) => {
            console.log("adjustDevice response", response);
            callback && callback(response.data)
        })
        .catch((error) => {
            console.error(`Error adjusting device: ${error.message}`);
            callback && callback(null);
        });
};

export const storeTokens = (json) => {
    if ("access_token" in json) {
        setCookie("access_token", json["access_token"], json["expires_in"] / 3600);
        setCookie("sl_refresh_token", json["refresh_token"], json["expires_in"] / 3600);
        setCookie("sl_expires_in", Date.now() + json["expires_in"] * 1000, json["expires_in"] / 3600);
    }
}

export function mergeDevices(newDevices, oldDevices) {
    if (!oldDevices) return newDevices;
    if (newDevices.length !== oldDevices.length) return newDevices;

    for (let i = 0; i < oldDevices.length; i++) {
        const oldDevice = oldDevices[i];
        const newDevice = newDevices[i];

        if (oldDevice.data && newDevice.data) {
            for (const prop in oldDevice.data) {
                if (!(prop in newDevice.data)) {
                    newDevice.data[prop] = oldDevice.data[prop];
                }
            }
        }
    }

    return newDevices;
}

export async function refreshToken(baseUrl) {
    const url = `${baseUrl}access.do`;
    const params = {
        grant_type: "refresh_token",
        refresh_token: getCookie("sl_refresh_token"),
        rand: Math.random(),
    };

    try {
        const response = await axios.get(url, { params });
        const json = response.data;
        const newInfo = storeTokens(json, true);
        return newInfo;
    } catch (error) {
        console.error("Error refreshing token:", error);
        throw error;
    }
}

export async function getDeviceList(baseUrl, devices, hasRefreshToken, callback) {
    if (hasRefreshToken === true) {
        await refreshToken(baseUrl);
    }

    const url = baseUrl + "skill";
    const headers = {
        "Content-Type": "application/json",
    };
    const data = {
        header: {
            name: "Discovery",
            namespace: "discovery",
            payloadVersion: 1,
        },
        payload: {
            accessToken: getCookie("access_token"),
        },
    };

    try {
        const response = await axios.post(url, data, { headers });
        const json = response.data;
        let result;
        if (json?.header?.code === "FrequentlyInvoke") {
            result = {
                devices: JSON.parse(localStorage.getItem('devices') || '[]'),
                success: true,
            };
        } else if (json?.payload?.devices) {
            const mergedDevices = mergeDevices(json.payload.devices.filter((device) => device.dev_type !== "scene"), devices);
            localStorage.setItem('devices', JSON.stringify(mergedDevices));
            result = {
                devices: mergedDevices,
                success: true,
            };
        } else {
            result = {
                devices: [],
                success: false,
            };
        }

        if (callback) callback(result.devices.filter((device) => device.dev_type !== "scene"));
    } catch (error) {
        console.error("Error fetching device list:", error);
        if (callback) callback({ devices: [], success: false });
    }
}